import React from 'react';
import { useSearchParams } from 'react-router-dom';
// Context
import ProgramContent from '../components/ProgramContent';
import { useSlideContent } from '../context/SlideContent';
// Helpers
import useStopScrolling from '../hooks/useStopScrolling';
// Hooks
import useResponsive from '../hooks/useResponsive';
import useAuthRedirect from '../hooks/useAuthRedirect';
// Components
import ProgramNavigationV2 from '../components/ProgramNavigationV2';

const Program = () => {
  const [searchParams] = useSearchParams();
  const navigationSize = searchParams.get('moduleView') ? 2 : 1;
  const { slideContent } = useSlideContent();
  const { isTablet, isLg } = useResponsive();

  useAuthRedirect();
  useStopScrolling(slideContent && isTablet);

  return (
    <div className="flex flex-col lg:flex-row w-full min-w-0 overflow-x-hidden">
      <ProgramNavigationV2 navigationSize={navigationSize} isLg={isLg} />
      <ProgramContent />
    </div>
  );
};

export default Program;
